import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { goToPage, setSubscriber } from '../../AddonsBlockSlice';
import { prepareSaleAsync, setErrorPageAsync } from '../../AddonsBlockAsyncThunk';
import Subscribers from '../../../../Shared/GeneralPages/Subscribers/Subscribers';
import { gtag4 } from '../../../../../utilities/analytics/tracking';

const SubscriberPage = (props) => {

    useEffect(() => {
        gtag4({ event: `Addon_${props.flowType}_Step1_SelectProductPage`, step: '1', action: 'SelectProductPage', funnel_name: `Addon_${props.flowType}` });
    }, []);

    return (<Subscribers saleType={'internet'} onSelectSubscriber={handleOnSelectSubscriber} selectedSubscriber={props.productSubscriberNo} />);


    function handleOnSelectSubscriber(subscriber) {
        gtag4({ event: `Addon_${props.flowType}_Step1_SelectProductContinueButton`, step: '1', action: 'SelectProductContinueButton', funnel_name: `Addon_${props.flowType}` });

        if (subscriber) {
            props.setSubscriber(subscriber);
            if (!subscriber.isJetService) {
                props.setErrorPageAsync({ error: 'NOT_JET_CUSTOMER_ERROR', isDisplayLoader: true });
                return;
            }
            if (subscriber.hasDebt || subscriber.hasPaymentMethodIssue) {
                props.setErrorPageAsync({ error: 'PAYMENT_OR_DEBT_ERROR', isDisplayLoader: true });
            }
            else {
                props.prepareSaleAsync();
            }
        }
        else {
            props.setErrorPageAsync({ error: 'NO_SUBSCRIBER_ERROR', isDisplayLoader: true });
        }
    }

};

const mapStateToProps = (state) => {
    return {
        flowType: state.addonsBlock.flowType,
        addonId: state.addonsBlock.addonId,
        productSubscriberNo: (state.selfcarePage?.isFetchData ? state.selfcarePage?.selectedSubscriber?.productSubscriberNo : '')
    };
};

const mapDispatchToProps = {
    goToPage,
    setSubscriber,
    setErrorPageAsync,
    prepareSaleAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberPage);
